// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

let QuietSellerPrivacy = {};

function validate(location) {
  if (location !== undefined) {
    return {
      TAG: "Ok",
      _0: Primitive_option.valFromOption(location)
    };
  } else {
    return {
      TAG: "Error",
      _0: "IsRequired"
    };
  }
}

let PropertyLocation = {
  validate: validate
};

function validatePrice(priceType, price) {
  if (priceType === "ExactPrice") {
    if (price !== undefined) {
      if (price < 50000) {
        return {
          TAG: "Error",
          _0: {
            NAME: "PriceMustBeGeq",
            VAL: 50000
          }
        };
      } else if (price > 250000000) {
        return {
          TAG: "Error",
          _0: {
            NAME: "PriceMustBeLeq",
            VAL: 250000000
          }
        };
      } else {
        return {
          TAG: "Ok",
          _0: Primitive_option.some(Scalars.PriceInput.fromInt(price))
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: "IsRequired"
      };
    }
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function validateMinPrice(priceType, minPrice) {
  if (priceType === "ExactPrice") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else if (minPrice !== undefined) {
    if (minPrice < 50000) {
      return {
        TAG: "Error",
        _0: {
          NAME: "PriceMustBeGeq",
          VAL: 50000
        }
      };
    } else if (minPrice > 250000000) {
      return {
        TAG: "Error",
        _0: {
          NAME: "PriceMustBeLeq",
          VAL: 250000000
        }
      };
    } else {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(Scalars.PriceInput.fromInt(minPrice))
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: "IsRequired"
    };
  }
}

function validateMaxPrice(priceType, minPrice, maxPrice) {
  if (priceType === "ExactPrice") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else if (maxPrice !== undefined) {
    if (maxPrice < 100000) {
      return {
        TAG: "Error",
        _0: {
          NAME: "PriceMustBeGeq",
          VAL: 100000
        }
      };
    } else if (maxPrice > 250000000) {
      return {
        TAG: "Error",
        _0: {
          NAME: "PriceMustBeLeq",
          VAL: 250000000
        }
      };
    } else if (minPrice !== undefined && maxPrice < minPrice) {
      return {
        TAG: "Error",
        _0: "MaxPriceMustBeGreaterThanMinPrice"
      };
    } else {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(Scalars.PriceInput.fromInt(maxPrice))
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: "IsRequired"
    };
  }
}

let ForSalePropertyPrice = {
  minPriceLowerLimit: 50000,
  maxPriceLowerLimit: 100000,
  priceUpperLimit: 250000000,
  validatePrice: validatePrice,
  validateMinPrice: validateMinPrice,
  validateMaxPrice: validateMaxPrice
};

function required(v) {
  if (v !== undefined) {
    return {
      TAG: "Ok",
      _0: Primitive_option.some(Primitive_option.valFromOption(v))
    };
  } else {
    return {
      TAG: "Error",
      _0: "IsRequired"
    };
  }
}

function optional(v) {
  if (v !== undefined) {
    return {
      TAG: "Ok",
      _0: Primitive_option.some(Primitive_option.valFromOption(v))
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function ignored(param) {
  return {
    TAG: "Ok",
    _0: undefined
  };
}

function validateBeds(propertyType, beds) {
  if (propertyType === "MultiUnit" || propertyType === "Lot") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return required(beds);
  }
}

function validateBaths(propertyType, baths) {
  if (propertyType === "MultiUnit" || propertyType === "Lot") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return required(baths);
  }
}

function validateHalfBaths(propertyType, halfBaths) {
  if (propertyType === "MultiUnit" || propertyType === "Lot") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return optional(halfBaths);
  }
}

function validateLivingArea(propertyType, livingArea) {
  if (propertyType === "MultiUnit" || propertyType === "Lot") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return optional(livingArea);
  }
}

function validateLotSize(propertyType, lotSize) {
  if (propertyType === "Lot") {
    return required(lotSize);
  } else if (propertyType === "MultiUnit") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return optional(lotSize);
  }
}

function validateNumberOfUnits(propertyType, numberOfUnits) {
  if (propertyType === "MultiUnit") {
    return required(numberOfUnits);
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

let ForSalePropertyAttributes = {
  required: required,
  optional: optional,
  ignored: ignored,
  validateBeds: validateBeds,
  validateBaths: validateBaths,
  validateHalfBaths: validateHalfBaths,
  validateLivingArea: validateLivingArea,
  validateLotSize: validateLotSize,
  validateNumberOfUnits: validateNumberOfUnits
};

function validate$1(emailAddress) {
  if (emailAddress === "") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let e = Scalars.EmailAddress.validate(emailAddress);
  if (e.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: Primitive_option.some(e._0)
    };
  } else {
    return {
      TAG: "Error",
      _0: "InvalidEmailAddress"
    };
  }
}

let ClientEmailAddress = {
  validate: validate$1
};

exports.QuietSellerPrivacy = QuietSellerPrivacy;
exports.PropertyLocation = PropertyLocation;
exports.ForSalePropertyPrice = ForSalePropertyPrice;
exports.ForSalePropertyAttributes = ForSalePropertyAttributes;
exports.ClientEmailAddress = ClientEmailAddress;
/* Scalars Not a pure module */
